import { orderRepository } from '@/infrastructure/repositories';
import {
  OrderListResponse,
  OrderDetailResponse,
  OrderFilters,
  UpdateOrderStatusDto,
  UpdateOrderCommentDto,
  CreateOrderDto,
} from '@/domain/entities';
import { HttpError } from '@/domain/entities';

export class OrderService {
  async getOrders(filters: OrderFilters = {}): Promise<OrderListResponse> {
    try {
      return await orderRepository.getAll(filters);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось загрузить список заказов');
    }
  }

  async getOrder(id: string): Promise<OrderDetailResponse> {
    try {
      return await orderRepository.getById(id);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось загрузить заказ');
    }
  }

  async updateStatus(id: string, payload: UpdateOrderStatusDto): Promise<OrderDetailResponse> {
    try {
      return await orderRepository.updateStatus(id, payload);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось обновить статус заказа');
    }
  }

  async updateComment(id: string, payload: UpdateOrderCommentDto): Promise<OrderDetailResponse> {
    try {
      return await orderRepository.updateComment(id, payload);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось обновить комментарий');
    }
  }

  async deleteOrder(id: string): Promise<void> {
    try {
      await orderRepository.delete(id);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось удалить заказ');
    }
  }

  async createOrder(payload: CreateOrderDto): Promise<OrderDetailResponse> {
    try {
      return await orderRepository.create(payload);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось создать заказ');
    }
  }
}

export const orderService = new OrderService();

